import Axios from 'axios'
import { Toast } from 'vant'
import { getToken } from '@/util/auth'

// 定义基础路径
// const BASE_URL = process.env.VUE_APP_BASE_URL
// 生成axios实例
const axios = Axios.create({
  // baseURL: BASE_URL,
  timeout: 10000,
  headers: {
    'x-channel': '2'
  }
})
// request interceptor
axios.interceptors.request.use(
  config => {
    const token = getToken()
    // do something before request is sent
    if (token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      // config.headers['X-Access-Token'] = token
      config.headers['x-token'] = token
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
axios.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    if (res.code === 200) {
      return res
    } else if (!res.code) {
      return response
    } else {
      Toast.fail(res.message || 'Error')
      console.error(res.message || 'Error')
      return Promise.reject(res)
    }
  },
  error => {
    console.log('err' + error) // for debug
    Toast.fail(error.message || 'Error')
    return Promise.reject(error)
  }
)

export const getReq = (url, data, opt = {}) => axios.get(url, {
  params: {
    // 防止ie浏览器缓存
    t: Date.now(),
    ...data
  },
  ...opt
})

export const delReq = (url, data, opt = {}) => axios.delete(url, {
  params: {
    t: Date.now(),
    ...data
  },
  ...opt
})

export const norReq = (url, data, method = 'post', opt = {}) => axios.request({
  url,
  method,
  data,
  ...opt
})

export default axios
